import { motion } from "framer-motion";
import { User, Sprout, CheckCircle2, Layers, Users, Infinity as InfinityIcon } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { WHY_DIFFERENT } from "@/data/content";

const ICONS = { User, Sprout, CheckCircle2, Layers, Users, Infinity: InfinityIcon };

export default function WhyDifferent() {
  return (
    <section className="py-24 sm:py-32 bg-cardbg" data-testid="why-different-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow="Why Aarogyam Bharat"
          title="Why Our Approach Is Different"
          sub="You are not buying a generic health plan. You are beginning a personalised coaching journey with Dr. Anjali."
        />
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {WHY_DIFFERENT.map((w, i) => {
            const Icon = ICONS[w.icon];
            return (
              <Reveal key={w.title} delay={i * 0.06}>
                <motion.div
                  whileHover={{ y: -6 }}
                  transition={{ duration: 0.35 }}
                  className="h-full bg-ivory border border-botanical/10 rounded-3xl p-8 shadow-card hover:shadow-hover transition-shadow duration-300 flex items-start gap-5"
                  data-testid={`why-card-${i}`}
                >
                  <div className="w-12 h-12 shrink-0 rounded-2xl bg-sagesurface flex items-center justify-center">
                    <Icon size={22} className="text-sage" />
                  </div>
                  <div>
                    <h3 className="text-sm font-extrabold uppercase tracking-[0.18em] text-forest">{w.title}</h3>
                    <p className="mt-2 text-sm leading-relaxed text-inkmuted">{w.text}</p>
                  </div>
                </motion.div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
